import {
  HStack,
  VStack,
  AspectRatio,
  Box,
  Heading,
  Icon,
  Image,
  Text,
  Circle,
} from '@chakra-ui/react';

import { AiFillEnvironment, AiOutlineShop } from 'react-icons/ai';
import { IoTimeSharp } from 'react-icons/io5';

import storeDefaultImage from '~/assets/images/defaultImage.png';

type RestaurantCardProps = {
  name?: string;
  logo?: string;
  image?: string;
  time?: string;
  address?: string;
  onNavigate?: () => void;
};

export default function RestaurantItem({
  name = '',
  logo = '',
  image = '',
  time = '',
  address = '',
  onNavigate,
}: RestaurantCardProps) {
  return (
    <VStack
      as="a"
      align="stretch"
      borderWidth="1px"
      borderColor="wsGray.500"
      onClick={onNavigate}
      borderRadius={5}
      pb={2}
      cursor="pointer"
    >
      <Box pos="relative">
        <AspectRatio ratio={5 / 3}>
          {image ? (
            <Image src={image} borderRadius={5} fallbackSrc={storeDefaultImage} />
          ) : (
            <Image src={storeDefaultImage} borderRadius={5} />
          )}
        </AspectRatio>
        {logo ? (
          <Image pos="absolute" top={1} left={2} src={logo} borderRadius="full" boxSize="2rem" />
        ) : (
          <Circle pos="absolute" top={1} left={2} size="2rem" bgColor="white">
            <Icon as={AiOutlineShop} color="primary" boxSize="1.25rem" />
          </Circle>
        )}
      </Box>
      <VStack px={2} flex="1" align="flex-start" overflow="hidden">
        <Heading fontSize="md" maxW={['9rem', '12rem', '14rem', '9rem']} isTruncated>
          {name}
        </Heading>

        <HStack overflow="hidden">
          <Icon as={AiFillEnvironment} boxSize="1.125rem" color="gray.500" />
          <Text
            fontSize="xs"
            color="gray.500"
            maxW={['8rem', '12rem', '14rem', '8rem']}
            isTruncated
          >
            {address}
          </Text>
        </HStack>

        <HStack>
          <Icon as={IoTimeSharp} boxSize="1.125rem" color="gray.500" />
          <Text
            fontSize="xs"
            color={['公休', '未營業'].includes(time) ? 'red.500' : 'gray.500'}
            isTruncated
          >
            {time}
          </Text>
        </HStack>
      </VStack>
    </VStack>
  );
}
